import styled from 'styled-components/macro';

import { devices } from 'shared/css/devices';
import { Card } from 'components';
import { fullCenter } from 'shared/css/common-classes';

import { LogoHeader } from 'shared/components/icons';

export const WrapperStyled = styled.main`
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
`;

export const LogoStyled = styled(LogoHeader)`
  ${({ theme: { spacing } }) => `
    margin: ${spacing?.(2)};
    height: ${spacing?.(8)};
    width: ${spacing?.(20)};
  `};
`;

export const LogoContainer = styled.div`
  width: 100%;
  height: auto;
`;

export const PanelStyled = styled.div`
  ${fullCenter};
  background-color: #ffffff;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TitleWrapperStyled = styled.div`
  ${({ theme: { spacing }, titleCentered }) => `
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: ${titleCentered ? 'center' : 'flex-start'};
    margin-bottom: ${spacing?.(4)};
    width: 100%;
    & svg {
      margin-bottom: 0;
      margin-right: ${spacing?.(2)};
      @media ${devices.tablet} {
        margin-bottom: ${titleCentered ? `${spacing?.(2)}` : '0'};
        margin-right: ${titleCentered ? '0' : `${spacing?.(2)}`};
      }
    }
    @media ${devices.tablet} {
      flex-direction: ${titleCentered ? 'column' : 'row'};
    }
  `};
`;

export const TitleStyled = styled.h1`
  ${({ theme: { colors = {}, typography } }) => `
    ${typography?.(20, 700)}
    color: ${colors.grey?.darkest};
    @media ${devices.mobileL} {
      ${typography?.(24, 700)}
    }
  `};
`;

export const CardStyled = styled(Card)`
  ${({ theme: { spacing } }) => `
    display: flex;
    flex-direction: column;
    margin: ${spacing?.(6)} ${spacing?.(2)} ${spacing?.(2)} ${spacing?.(2)};
    padding: ${spacing?.(2)};
    width: 90%;
    z-index: 1;
    @media ${devices.tablet} {
      padding: ${spacing?.(7)};
      width: ${spacing?.(75)};
    }
  `};
`;

export const StepsStyled = styled.div`
  ${({ theme: { colors = {}, typography, spacing } }) => `
    ${typography?.(20, 700)}
    color: ${colors.grey?.darker};
    margin-bottom: ${spacing?.(3)};
    width: 100%;
  `};
`;

export const MessageStyled = styled.p`
  ${({ theme: { typography } }) => `
    ${typography?.(16)}
  `};
`;

export const ExternalLink = styled.a`
  ${({ theme: { colors = {}, links = {}, transitions, typography } }) => `
    ${typography?.(16)}
    cursor: pointer;
    color: ${colors.base.altusTeal.default};
    text-decoration: ${links.textDecoration};
    transition: all ${transitions?.fast} ease-in-out;
    &:hover, &:focus {
      text-decoration: ${links.hover?.textDecoration};
    }
  `};
`;
